import {
  FormControl,
  Switch,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  IconButton,
} from "@chakra-ui/react";
import { FormLabel } from "@chakra-ui/react";
import { ReactNode } from "react";
import { IoIosHelpCircleOutline } from "react-icons/io";

interface SettingsToggleProps {
  label: string;
  isChecked: boolean;
  onChange: () => void;
  isDisabled: boolean;
  helpContent?: ReactNode;
}

export const SettingsToggle = ({
  label,
  isChecked,
  onChange,
  isDisabled,
  helpContent,
}: SettingsToggleProps) => {
  return (
    <FormControl
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <div className="flex items-center gap-2">
        <FormLabel mb="0" fontSize={{}}>
          {label}
        </FormLabel>

        {helpContent && (
          <Popover placement="top">
            <PopoverTrigger>
              <IconButton
                aria-label="Help"
                icon={<IoIosHelpCircleOutline size={18} />}
                size="xs"
                variant="ghost"
                color="var(--color-grey)"
                _hover={{
                  backgroundColor: "var(--color-grey-lightest)",
                }}
                _active={{
                  backgroundColor: "var(--color-grey-lightest)",
                }}
              />
            </PopoverTrigger>
            <PopoverContent maxW="280px" borderRadius="xl">
              <PopoverArrow />
              <PopoverCloseButton />
              <PopoverBody>{helpContent}</PopoverBody>
            </PopoverContent>
          </Popover>
        )}
      </div>
      <Switch
        size="lg"
        isChecked={isChecked}
        onChange={onChange}
        isDisabled={isDisabled}
        sx={{
          "& .chakra-switch__track[data-checked]": {
            backgroundColor: "var(--color-blue)",
          },
        }}
      />
    </FormControl>
  );
};
